import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { GeoreferenceParentType } from '~/apollo/generated/v4/graphql';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { GeoreferenceManagerV4 } from '~/components/upload/georeference-v4/georeference-manager';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const GEOREFERENCES_PAGE = graphql(`
  query UploadRegionUpdateGeoreferencesTab($id: ID!) {
    regionGet(id: $id) {
      id
      georeferences {
        ...georeferenceParts
      }
    }
  }
`);

export default function UploadRegionUpdateGeoreferencesPage() {
  return (
    <ApolloProviderV4>
      <UploadRegionUpdateGeoreferencesPageInner />
    </ApolloProviderV4>
  );
}

function UploadRegionUpdateGeoreferencesPageInner() {
  const regionId = useRouteParam('regionId', parseInt);

  const { data, loading } = useQuery(GEOREFERENCES_PAGE, {
    variables: { id: regionId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: GEOREFERENCES_PAGE,
      variables: { id: regionId },
    },
  ]);

  const region = data?.regionGet;
  const georeferences = region?.georeferences ?? [];

  if (loading) return <SpinnerPlaceholder />;
  if (!region) return <NotFound />;

  return (
    <GeoreferenceManagerV4
      georeferences={georeferences}
      parentType={GeoreferenceParentType.Region}
      parentId={parseInt(region.id)}
      refetchQueries={refetchQueries}
    />
  );
}
